// Convert duration to formatted string
function durationToTranslatedStr(duration, str) {
  const { day, hour, minute } = str

  return `${Math.floor(
    duration.asDays(),
  )}${day} ${duration.hours()}${hour} ${duration.minutes()}${minute}`
}

export default durationToTranslatedStr
